import { PartialNullable } from "../../Extensions";
import { IPromisePublic, PromiseHelper } from "../../Helpers/PromiseHelper";
import { Property } from "../../RadObject";
import { AjaxError } from "../../Server/AjaxError";
import { ButtonStyleEnum } from "./ButtonStyleEnum";
import { IMessageDialog, MessageDialog, MessageDialogPropertyValues } from "./MessageDialog";
import { NAMESPACE } from "./_Namespace";

export type ErrorDialogPropertyValues =
    MessageDialogPropertyValues
    & {
    };

export type ErrorDialogProperties = {
    [name in keyof ErrorDialogPropertyValues]: Property<ErrorDialogPropertyValues[name]>
};

export interface IErrorDialog extends IMessageDialog, ErrorDialogProperties
{
}

let
    errorDialog: ErrorDialog,
    errorQueue: any[] = [],
    promiseQueue: IPromisePublic[] = [];

function checkQueue()
{
    if (!errorDialog)
        errorDialog = new ErrorDialog();

    if (!errorDialog.opened && errorQueue.length)
    {
        errorDialog.openAsync(errorQueue.shift())
            .finally(() =>
            {
                checkQueue();
            });
    }
    else
    {
        while (promiseQueue.length)
            promiseQueue.shift()?.resolve();
    }
}

export class ErrorDialog extends MessageDialog implements IErrorDialog
{
    // #region Static

    public static override classNamespace = NAMESPACE + "ErrorDialog";
    public static override className = "ErrorDialog";

    // #region Public Methods

    public static displayError(error: any): IPromisePublic
    {
        if (error)
            console.trace(error);

        const
            promise = PromiseHelper.createPromisePublic();

        if (!error)
        {
            promise.resolve();
            return promise;
        }

        promiseQueue.push(promise);

        errorQueue.push(error);
        checkQueue();

        return promise;
    }

    // #endregion

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<ErrorDialogPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                buttonStyle: ButtonStyleEnum.okOnly,
                title: "Error",
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<ErrorDialogPropertyValues>)
    {
        super(propertyValues);

        this.addCssClass("rad-control-error-dialog");
    }

    // #endregion

    // #region Overrides

    public override openAsync(error: AjaxError | Error | string)
    {
        if (error instanceof AjaxError)
        {
            let
                title = error.type.get(),
                errorMessage = error.message.get();

            if (error.type.get() === "ValidationApiException")
            {
                const
                    validationErrors = error.validationErrors.get();

                title = "A validation error occurred:";
                errorMessage = validationErrors ? validationErrors.map(item => `${item.errorMessage} (${item.entityName})`).join(", ") : "Unknown error";
            }

            this.title.set(title);
            this.text.set(errorMessage);
        }
        else if (error instanceof Error)
        {
            this.title.set("The following error occurred:");
            this.text.set(error.message);
        }
        else if (typeof error === "string")
        {
            this.title.set("The following error occurred:");
            this.text.set(error);
        }
        else
        {
            this.title.set("Unknown error");
            this.text.set("An unknown error occurred");
        }

        return super.openAsync(error);
    }

    // #endregion

    // #endregion
}